module.exports = __webpack_public_path__ + "809f640e20fadf999030c154ac123dff.jpg";